import { BN } from '@coral-xyz/anchor'
import { round } from 'lodash'
import { twMerge } from 'tailwind-merge'
import { clsx, type ClassValue } from 'clsx'
import { ReadonlyURLSearchParams } from 'next/navigation'

export const getQueryString = (
  params: ReadonlyURLSearchParams,
  key: string,
  value: string,
) => {
  const current = new URLSearchParams(Array.from(params.entries()))

  if (!value || value === "false" || value === '') {
    current.delete(key)
  } else {
    current.set(key, value)
  }

  const search = current.toString()
  const query = search ? `?${search}` : ''

  return query
}

export function isValidUrl(url: string) {
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

export function getUrlFromString(str: string) {
  if (isValidUrl(str)) return str
  try {
    if (str.includes('.') && !str.includes(' ')) {
      return new URL(`https://${str}`).toString()
    }
  } catch (e) {
    return null
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const removeDashAndCapitalize = (str: string) => {
  return str.replace(/-/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())
}

export const formatLargeNumber = (number: BN) => {
  const BILLION = new BN(1_000_000_000)
  const MILLION = new BN(1_000_000)
  const THOUSAND = new BN(1_000)

  if (number.gte(BILLION)) {
    return [round(number.div(BILLION).toNumber(), 2), 'B'].join('')
  }
  if (number.gte(MILLION)) {
    return [round(number.div(MILLION).toNumber(), 2), 'M'].join('')
  }
  if (number.gte(THOUSAND)) {
    return [round(number.div(THOUSAND).toNumber(), 2), 'K'].join('')
  }

  return number.toString()
}
